<template lang="pug">
component(v-bind="compProps" v-on="compEvents")
    slot
</template>

<script>
import SearchComponent from './component'

export default {
    extends: SearchComponent,
    props: {
        pageNumber: {
            type: Number,
            required: true,
        },
        updateRoute: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        compProps() {
            if (this.updateRoute)
                return {
                    is: 'nuxt-link',
                    to: this.createRouteObj(),
                }

            return {
                is: 'button',
            }
        },
        compEvents() {
            if (this.updateRoute) return
            return {
                click: this.updatePage,
            }
        },
    },
    methods: {
        updatePage() {
            // Update the page without impacting the URL
            this.$searchContext.setPage(this.pageNumber)
            this.$searchContext.search()
        },
        createRouteObj() {
            // eslint-disable-next-line no-unused-vars
            const { page, ...restOfQuery } = this.$route.query

            return {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...restOfQuery,
                    ...(this.pageNumber > 1 && { page: this.pageNumber }),
                },
            }
        },
    },
}
</script>
